module.exports = __webpack_public_path__ + "static/media/1003000MF.f4a0d381.jpg";